var _classCallCheck = require("/home/chad.schellenger/Development/shopwcw/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/chad.schellenger/Development/shopwcw/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Detail = require('./Detail');

var Sku =
/*#__PURE__*/
function () {
  "use strict";

  function Sku() {
    _classCallCheck(this, Sku);

    this.id = null;
    this.name = null;
    this.imgSrc = null;
    this.video = null;
    this.description = null;
    this.price = null;
    this.details = [];
    this.available = 0;
    this.sort = 0;
    this.deliveryMin = 6;
    this.deliveryMax = 18;
    this.xmas = false;
    this.isChristmas = this.isChristmas.bind(this);
  }

  _createClass(Sku, [{
    key: "isChristmas",
    value: function isChristmas() {
      return this.xmas;
    }
  }]);

  return Sku;
}();

function createSku(object) {
  var sku = new Sku();
  sku.id = object.id;
  sku.name = object.name;
  sku.imgSrc = object.imgSrc;
  sku.video = object.video;
  sku.description = object.description;
  sku.price = object.price;

  if (Array.isArray(object.details)) {
    sku.details = object.details.map(function (d) {
      return Detail.createDetail(d);
    });
  }

  sku.available = object.available;
  sku.sort = object.sort;
  sku.deliveryMin = object.deliveryMin;
  sku.deliveryMax = object.deliveryMax;
  sku.xmas = object.xmas;
  return sku;
}

module.exports = {
  sku: Sku,
  createSku: createSku
};